import { NgClass } from '@angular/common';
import { Component, OnInit } from '@angular/core';

import { UaService } from '@ecm/consumer';
import { LinkService, RouterService } from '@ecm/router';

import { UrlService } from '../../../../services/url.service';
import { SubItemComponent } from '../sub-item.component';

@Component({
    selector: 'picto-sub-item',
    templateUrl: 'picto-sub-item.html',
    styleUrls: ['../sub-item.css'],
    standalone: true,
    imports: [NgClass],
})
export class PictoSubItemComponent extends SubItemComponent implements OnInit {
    public constructor(
        protected uaService: UaService,
        protected routerService: RouterService,
        protected linkService: LinkService,
        protected urlService: UrlService,
    ) {
        super(uaService, routerService, linkService, urlService);
    }
}
